import { render, staticRenderFns } from "./DealerVerifyCoupon.vue?vue&type=template&id=b56550c2&scoped=true"
import script from "./DealerVerifyCoupon.vue?vue&type=script&lang=js"
export * from "./DealerVerifyCoupon.vue?vue&type=script&lang=js"
import style0 from "./DealerVerifyCoupon.vue?vue&type=style&index=0&id=b56550c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b56550c2",
  null
  
)

export default component.exports